/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    parent: require('../../../model/pagination/PaginationList'),
    method: {
        init: function () {
            this.setOpts({
                list: {
                    itemType: require('../view/OrderListItem'),
                    itemModelType: require('./OderListItem')
                }
            });

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/model/OrderList.js
// module id = 680
// module chunks = 3